import { render } from "./ReviewPromptPopup.vue?vue&type=template&id=2a6d89f7&scoped=true"
import script from "./ReviewPromptPopup.vue?vue&type=script&lang=js"
export * from "./ReviewPromptPopup.vue?vue&type=script&lang=js"

import "./ReviewPromptPopup.vue?vue&type=style&index=0&id=2a6d89f7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6d89f7"]])

export default __exports__